const isCrossOriginScriptError = (message, filename = "") => {
  if (message !== "Script error.") return false;
  if (!filename) return true;

  return !(
    filename.startsWith(window.location.origin) ||
    filename.startsWith("webpack://") ||
    filename.includes("/static/js/bundle")
  );
};

const suppressCrossOriginScriptErrorEvent = (event) => {
  if (!isCrossOriginScriptError(event.message, event.filename)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
};

// Register before the app bundle so CRA's error overlay does not surface these.
window.addEventListener("error", suppressCrossOriginScriptErrorEvent, true);
window.addEventListener("error", suppressCrossOriginScriptErrorEvent, false);

const previousOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (isCrossOriginScriptError(message, source)) {
    return true;
  }
  if (typeof previousOnError === "function") {
    return previousOnError(message, source, lineno, colno, error);
  }
  return false;
};
